import type { CatalogAssetResponse } from "../../generated/api/types.gen";
import { AssetThumbnailImage } from "../gallery/GalleryAssetGrid";

interface SourceAssetCardProps {
  asset: CatalogAssetResponse;
  onSave: (assetId: string) => void;
}

/**
 * One manufacturer product on the Source screen: swatch or photo with its
 * catalog category as a tag (never the supplier's own label), the maker and
 * name, and the save action. "See Details" from the design waits on the asset
 * details screen.
 */
export function SourceAssetCard({ asset, onSave }: SourceAssetCardProps) {
  const isSaved = asset.in_library;

  return (
    <li
      aria-label={asset.name}
      className="flex flex-col overflow-hidden rounded-lg drop-shadow-[0_0_2px_rgba(32,38,44,0.6)]"
    >
      <div
        className="relative flex h-[171px] flex-col items-end overflow-hidden rounded-lg p-3"
        style={
          asset.type === "color" ? { backgroundColor: asset.value } : undefined
        }
      >
        {asset.type === "image" && (
          <div className="absolute inset-0 overflow-hidden rounded-lg">
            <AssetThumbnailImage src={asset.value} className="h-full w-full" />
          </div>
        )}
        {asset.catalog_category && (
          <span className="relative rounded-[36px] bg-white/60 px-2.5 py-0.5 text-[9px] leading-5 font-semibold whitespace-nowrap text-[#20262c]">
            {asset.catalog_category}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-3 p-3">
        <div className="flex min-w-0 flex-col leading-5 text-(--text-primary)">
          <span className="truncate text-[11px] font-medium">
            {asset.manufacturer}
          </span>
          <span className="truncate text-[15px] font-bold" title={asset.name}>
            {asset.name}
          </span>
        </div>
        <button
          type="button"
          onClick={() => onSave(asset.id)}
          disabled={isSaved}
          className="self-start rounded border border-[#3c7ca5] bg-[rgba(54,112,149,0.75)] px-3 py-0.5 text-[9px] leading-5 font-medium text-white transition-colors hover:bg-[#3c7ca5] disabled:cursor-default disabled:bg-[rgba(60,124,165,0.25)] disabled:hover:bg-[rgba(60,124,165,0.25)]"
        >
          {isSaved ? "Saved" : "Save to Asset"}
        </button>
      </div>
    </li>
  );
}
